module.exports = __webpack_public_path__ + "img/AG.b58f7f0a.png";